export default function initDownloadPdfUrl(element) {
	const language = document.documentElement.getAttribute('data-lang') || document.documentElement.getAttribute('lang') || 'en-US';
	const pageId = element.getAttribute(["data-page-reference"]);

	const url = `https://${window.location.hostname}/api/healthcheck/GetSummaryPdf/${pageId}/${language}`;

	document.querySelector('[data-fn="initDownloadPdfUrl"]').setAttribute('href', url);
}
